<template>
	<div class="patient-appointments">
		<template v-if="loading">
			<v-row no-gutters justify="center" align="center" style="height: 600px;">
				<v-progress-circular
					:size="50"
					color="primary"
					indeterminate
				></v-progress-circular>
			</v-row>
		</template>
		<template v-else>
		<p v-if="appointments.length == 0" class="font-weight-thin ml-2 mt-6">No appointments.</p>
		<v-list v-else flat>
			<v-card class="mx-auto mb-1" v-for="(appointment) in appointments" :key="appointment.id" elevation="1">
				<v-list-item
					three-line
					color="primary"
					:style="!appointment.effective ? {opacity: 0.7} : {}"
				>
					<v-list-item-content>
						<v-list-item-title class="primary--text">
							<v-row no-gutters class="text-body-1">
								<v-icon class="mr-1" small color="primary">mdi-account-tie</v-icon>
								<span class="mr-2">{{appointment.user.name}}</span>
								<v-icon class="mr-1" small color="primary">mdi-certificate</v-icon>
								<span>{{appointment.speciality.name}}</span>
								<v-spacer></v-spacer>
								<v-chip class="mr-2" small v-if="!appointment.effective"><translate>Scheduled</translate></v-chip>
								<v-icon class="mr-1" small color="primary">mdi-calendar</v-icon>
								<span class="mr-2">{{appointment.date}}</span>
								<v-icon class="mr-1" small color="primary">mdi-clock-outline</v-icon>
								<span>{{appointment.time}}</span>
							</v-row>
						</v-list-item-title>
						<v-list-item-subtitle>
							<v-row no-gutters>
							{{appointment.description}}
							<v-spacer></v-spacer>
							<span v-if="appointment.price" class="text--overline font-weight-bold primary--text">
								{{appointment.price}}€
							</span>
							</v-row>
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-card>
		</v-list>
		<v-btn
			small
			fab
			color="primary"
			:to="{name: 'patient-new-appointment', params: {pid: patientId, patient: patient}}"
			:disabled="!$store.getters.hasAnyModule"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>
		</template>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "PatientAppointments",
	props: ["patientId", "patient"],
	data: () => ({
		loading: true,
		appointments: []
	}),
	created() {
		const id = this.$route.params.pid;
			axios
				.get("/patient/" + id + "/appointments")
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						this.loading = false;
						this.appointments = response.data.appointments;
					}
				})
				.catch(error => console.log(error));
	}
};
</script>